goog.provide('el8.appchart.reportFeeds.renderer');

goog.require('el8.appchart.reportFeeds.actions');
goog.require('el8.service.tz');
goog.require('el8.model.identify');
goog.require('el8.template.render.reportFeedItem');

el8.appchart.reportFeeds.renderer = function(item) {

    var mClass = item.getModelClass();

    switch (mClass) {
        case "Report":
            return function(item, feedId) {
                return el8.template.render.reportFeedItem.baseItem({
                    feedId: feedId,
                    feedItemId: item.getFeedItemId(),
                    documentDate: el8.service.tz.soyStr(item.getDocumentDate()),
                    isSignedOff: item.isSignedOff(),
                    description: item.getDescription(),
                    abnormalResultsStr: (item.getReportType() === 'lab') && item.hasGrids() ? item.getDisplayAbnormalResults() : null,
                    cardSummary: item.getCardSummary(),
                    reportType: item.getReportType(),
                    fromLetterReceiptId: item.getFromLetterReceiptId(),
                    fromLetterReceiptSender: item.getFromLetterReceiptId() ? item.getFromLetterReceipt().getSenderName() : null,
                    buttonsInfo: el8.appchart.reportFeeds.actions.buttons(item),
                    isConfidential: item.isConfidential()
                });
            };
        case "LabOrder":
        case "ImagingOrder":
        case "SleepOrder":
        case "CardiacOrder":
        case "PulmonaryOrder":
        case "ReferralOrder":
            return function(item, feedId) {
                if (el8Globals.FEATURES.BiDiLabs) {
                    return el8.template.render.reportFeedItem.baseItem({
                        feedId: feedId,
                        feedItemId: item.getFeedItemId(),
                        documentDate: el8.service.tz.soyStr(item.getDocumentDate()),
                        isSignedOff: item.isSignedOff(),
                        isOrder: true,
                        description: item.getDescription(),
                        buttonsInfo: el8.appchart.reportFeeds.actions.buttons(item),
                        currentState: item.getCurrentState()
                    });
                } else {
                    return el8.template.render.reportFeedItem.baseItem({
                        feedId: feedId,
                        feedItemId: item.getFeedItemId(),
                        documentDate: el8.service.tz.soyStr(item.getDocumentDate()),
                        isSignedOff: item.isSignedOff(),
                        isOrder: true,
                        description: item.getDescription(),
                        buttonsInfo: el8.appchart.reportFeeds.actions.buttons(item)
                    });
                }
            };
        case "VisitNote":
        case "NonvisitNote":
            return function(item, feedId) {
                return el8.template.render.reportFeedItem.baseItem({
                    feedId: feedId,
                    feedItemId: item.getFeedItemId(),
                    documentDate: el8.service.tz.soyStr(item.getDocumentDate()),
                    isSignedOff: item.isSignedOff(),
                    description: item.getDescription(),
                    buttonsInfo: el8.appchart.reportFeeds.actions.buttons(item)
                });
            };
        default:
            break;
    }
};

